import React, { useEffect, useState, useRef } from 'react';
import ColumnManagement from './ColumnManagement';
import TableList from './TableList';
import { Button } from 'primereact/button';
import TableCrud from './TableCrud';
import service from './services/service';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';

export const TableManagement = (props) => {

    const [isCreateTable, setIsCreateTable] = useState(false);
    const [isDataAdd, setIsDataAdd] = useState(false);
    const [table, setTable] = useState(null);
    const toast = useRef(null);
    const tableTypes = [
        window.Object.checkPermissions(["table_management_add_tree"]) &&   {
            name: 'Ağaç Tablosu', type: 1,
            defaultColumns: [
                {
                    name: 'name',
                    type: 'String',
                    required: true,
                    isActive: true,
                    isCompulsory: true,                    
                },
                {
                    name: 'parent_id',
                    type: 'Int64',
                    required: false,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'layertype',
                    type: 'Int32',
                    required: false,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'geoloc',
                    type: 'Geometry',
                    required: false,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'poi',
                    type: 'Geometry',
                    required: false,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'backgroundcolor',
                    type: 'String',
                    required: false,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'icon',
                    type: 'String',
                    required: false,
                    isActive: true,
                    isCompulsory: true
                }

            ], alias: 'tree'
        },
        window.Object.checkPermissions(["table_management_add_customer"]) &&   { name: 'Müşteri Tablosu', type: 2, defaultColumns: [], alias: 'customer' },
        window.Object.checkPermissions(["table_management_add_dynamic_table"]) &&     { name: 'Dinamik Tablo', type: 3, defaultColumns: [], alias: 'dynamic' },
        window.Object.checkPermissions(["table_management_add_waybill_table"]) &&      {
            name: 'İrsaliye Tablosu', type: 4,
            defaultColumns: [
                {
                    name: 'tarih',
                    type: 'DateTime',
                    required: true,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'irsaliye_tipi',
                    type: 'Int32',
                    required: true,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'tutar',
                    type: 'Double',
                    required: true,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'adet',
                    type: 'Double',
                    required: true,
                    isActive: true,
                    isCompulsory: true
                },
                {
                    name: 'desi',
                    type: 'Double',
                    required: true,
                    isActive: true,
                    isCompulsory: true
                    
                },
                {
                    name: 'musteri_id',
                    type: 'Int32',
                    required: true,
                    isActive: true,
                    isCompulsory: true

                },
                {
                    name: 'musteri_adi',
                    type: 'String',
                    required: true,
                    isActive: true,
                    isCompulsory: true

                },
                {
                    name: 'geoloc',
                    type: 'Geometry',
                    required: false,
                    isActive: true,
                    isCompulsory: true
                }
            ],
            alias:'waybill'
        },
    ].filter(x=>x);
    const [selectedTableType, setSelectedTableType] = useState(tableTypes[0]);

    const downloadExcelReport = async () => {
        service.getFileRequest(props.apiUrl + "/DynamicFileExport/ExportExcelFile?_tableId=" + table.id).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            return response.blob();
        }).then(blob => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            // Create a link element
            const link = document.createElement('a');
            link.href = url;
            // Specify the file name for the download
            link.setAttribute('download', table.tableName+'.xlsx');
            // Append the link to the body
            document.body.appendChild(link);
            // Click the link to trigger the download
            link.click();
            // Clean up
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        });

    }

    useEffect(() => {
        window["dynamicTableApiToken"] = props.tokenKey;

    }, [])
    return (
        <div id={props.id} >
            <Toast ref={toast} />
      
            <br />
            {(isCreateTable && !isDataAdd) && <ColumnManagement
                toast={toast}
                table={table}  {...props} selectedTable={selectedTableType} tableTypes={tableTypes}  onComplete={() => {
                    setIsCreateTable(false);
                    setIsDataAdd(false);

                }}
            />}

            { <>
                {(!isCreateTable && !isDataAdd) && <TableList
                    toast={toast}
                    onCreateTable={() => {

                        
                        setTable(null);
                        setTimeout(() => {
                            setIsCreateTable(true);
                        }, 500);
                        
                    }}
                    onSelected={(data) => {
                        setTable(data);
                        setIsCreateTable(true);
                        setIsDataAdd(false);
                    }}
                    onDataAdd={(data) => {
                        setIsCreateTable(true);
                        setIsDataAdd(true);
                        setTable(data);

                    }}
                    selectedTableType={selectedTableType}
                    tableTypes={tableTypes}
                    {...props}
                />}
            </>}
            {isDataAdd && <TableCrud table={table} {...props} onComplete={() => {
                setIsCreateTable(false);
                setIsDataAdd(false);
            }} />}
        </div>)



}

export default TableManagement;